import { render } from "./PopupMessage.vue?vue&type=template&id=63ef3948"
import script from "./PopupMessage.vue?vue&type=script&lang=js"
export * from "./PopupMessage.vue?vue&type=script&lang=js"

import "./PopupMessage.vue?vue&type=style&index=0&id=63ef3948&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__